<div class="jira_integration">
    <div class="jira_integration_top">
        <div class="top_left">
            <div class="top_left_logo">
                <img src="../../../assets/images/jira-2.svg">
            </div>
            <div class="top_left_heading">
                Setting / Integration's
                <p>Manage Integration's</p>
            </div>

        </div>
        <div class="top_right">
            <div class="top_right_logo">
                <a (click)="navigatePreviousUrl()">
                    <span class="close-icon" matTooltip="close" uk-icon="close"></span>
                </a>
            </div>
            <div class="top_right_content">
                <div class="top_right_heading">
                    <span class="material-symbols-outlined">
                        play_circle
                    </span>
                    Installation Guide
                </div>
                <span class="material-symbols-outlined">
                    more_horiz
                </span>
            </div>

        </div>
    </div>
    <div class="jira_integration_middle">
        <div class="middle_left">
            <img src="../../../assets/images/back2.jpg">
        </div>
        <div *ngIf="!isJiraIntegrationExists" class="middle_right">
            <h3>Welcome to {{brand.brandName}} Integration's for Jira!</h3>
            <p>You have no integration yet.<br>
                Add an integration to get started.</p>
            <button><a href="javascript:void(0)" (click)="integrateJira()">Add
                    Integration</a></button>
        </div>
        <div *ngIf="isJiraIntegrationExists" class="middle_right">
            <h3>Integration Successful!</h3>
            <p>Your {{brand.brandName}} integration is now <span>Active.</span> <br>
                You can now start using the features to streamline your workflow.
            </p>
        </div>
    </div>
    <div class="jira_integration_bottom">
        <ng-container *ngIf="isJiraIntegrationExists">
            <div class="sync-wrapper">
                <button [disabled]="isSyncingInprogress" (click)="syncJiraProject()">
                    {{ isSyncingCompleted ? 'Re-Sync Jira Project' : 'Sync Jira Project' }}
                </button>

                <!-- Inline Loader next to button -->
                <div class="inline-loader" *ngIf="isSyncingInprogress">
                    <ze-loader></ze-loader>
                </div>
            </div>
        </ng-container>

        <!-- Support button below sync -->
        <div class="support-wrapper">
            <button>
                Get Integration Support
            </button>
        </div>
    </div>
</div>